// {{WORKTREE_ROOT}}/picosponsorconsole/app/components/auth/AuthFrame.tsx
// PLAN2 WP10 + PLAN6 WP6-07 — [B-SIGNIN-1440 · 390 L1059–L1099]. Split layout: the dark brand band (sentence-case keeper headline,
// last line on the on-dark accent) beside a 420 px form panel (<main>); below md only the panel shows, with its own wordmark.
import type { ReactNode } from "react";
import { Wordmark } from "@picosponsor/design";
import { useT } from "~/utils/locale";
import { TESTIDS } from "~/utils/testids";

export function AuthFrame({ children, regionLine, testId }: { children: ReactNode; regionLine?: string | null; testId: string }) {
  const t = useT();
  const lines = t("common", "keeper-promise-prove-renew").split(/(?<=\.)\s+/);
  return (
    <div className="min-h-screen cq-md:grid cq-md:grid-cols-[1fr_420px]" data-testid={testId}>
      <div className="band hidden flex-col justify-between bg-band-bg p-14 cq-md:flex">
        <Wordmark size={24} />
        <p className="display m-0 text-56 leading-0.95 tracking-tight-45 text-band-ink">
          {lines.map((l, i) => (
            <span key={i} className={i === lines.length - 1 ? "block text-accent-on-dark" : "block"}>{l}</span>
          ))}
        </p>
        <p className="mono m-0 text-12 text-band-faint">{t("common", "keeper-category-line")}</p>
      </div>
      <main id="main" className="flex min-h-screen flex-col gap-4 bg-bg px-5 py-7 cq-md:gap-4.5 cq-md:px-10 cq-md:py-12">
        <div className="cq-md:hidden"><Wordmark size={20} /></div>
        {children}
        {regionLine ? <p className="mono m-0 mt-auto text-11 text-faint" data-testid={TESTIDS.auth.signin.regionLine}>{regionLine}</p> : null}
      </main>
    </div>
  );
}
